import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/docs/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "how-to-add-documents-to-your-project",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#how-to-add-documents-to-your-project",
        "aria-label": "how to add documents to your project permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`How to add documents to your project`}</h1>
    <p>{`Create a /docs folder in your project and add the run-docz.sh to that folder.`}</p>
    <p>{`Then add a step to your bitbucket-pipelines.yml file that looks like this:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "yaml"
    }}><pre parentName="div" {...{
        "style": {
          "counterReset": "linenumber NaN"
        },
        "className": "language-yaml line-numbers"
      }}><code parentName="pre" {...{
          "className": "language-yaml"
        }}>{`    `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`step`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token important"
          }}>{`&build-docs`}</span>{`
        `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`name`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` Build Docs
        `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`image`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{`
          `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`name`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` youngliving/docs`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{`latest
          `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`username`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` $DOCKER_HUB_USER
          `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`password`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` $DOCKER_HUB_PASS
        `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`script`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{`
          `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{` export PATH_PREFIX=/SOME_PATH
          `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{` mv docs /docs/content 
          `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{` cd /docs `}<span parentName="code" {...{
            "className": "token important"
          }}>{`&&`}</span>{` npm run build `}<span parentName="code" {...{
            "className": "token important"
          }}>{`&&`}</span>{` cd `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{`
          `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{` mv /docs/public dist
        `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`artifacts`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{`
          `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'dist/**'`}</span>{`       
    `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`step`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token important"
          }}>{`&deploy-docs`}</span>{`
        `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`name`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` Deploy Docs
        `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`image`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` atlassian/pipelines`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{`awscli`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{`latest
        `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`script`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{`
          `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`pipe`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` atlassian/aws`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{`s3`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{`deploy`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{`0.2.4
            `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`variables`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{`
              `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`AWS_ACCESS_KEY_ID`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` $DOCS_AWS_ACCESS_KEY_ID
              `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`AWS_SECRET_ACCESS_KEY`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` $DOCS_AWS_SECRET_ACCESS_KEY
              `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`AWS_DEFAULT_REGION`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` $DOCS_AWS_DEFAULT_REGION
              `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`S3_BUCKET`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` $DOCS_S3_BUCKET/SOME_PATH
              `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`LOCAL_PATH`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'dist'`}</span>{`
              `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`CACHE_CONTROL`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`"$DOCS_CACHE_CONTROL"`}</span>{`
              `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`DELETE_FLAG`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'true'`}</span>{`
          `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{` export AWS_DEFAULT_REGION=$DOCS_AWS_DEFAULT_REGION
          `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{` export AWS_ACCESS_KEY_ID=$DOCS_AWS_ACCESS_KEY_ID
          `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{` export AWS_SECRET_ACCESS_KEY=$DOCS_AWS_SECRET_ACCESS_KEY
          `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{` aws cloudfront create`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{`invalidation `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{`distribution`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{`id $DOCS_AWS_CLOUDFRONT_DIST_ID `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{`paths "/`}<span parentName="code" {...{
            "className": "token important"
          }}>{`*"`}</span>{` `}</code><span parentName="pre" {...{
          "aria-hidden": "true",
          "className": "line-numbers-rows",
          "style": {
            "whiteSpace": "normal",
            "width": "auto",
            "left": "0"
          }
        }}><span parentName="span"></span><span parentName="span"></span><span parentName="span"></span><span parentName="span"></span><span parentName="span"></span><span parentName="span"></span><span parentName="span"></span><span parentName="span"></span><span parentName="span"></span><span parentName="span"></span><span parentName="span"></span><span parentName="span"></span><span parentName="span"></span><span parentName="span"></span><span parentName="span"></span><span parentName="span"></span><span parentName="span"></span><span parentName="span"></span><span parentName="span"></span><span parentName="span"></span><span parentName="span"></span><span parentName="span"></span><span parentName="span"></span><span parentName="span"></span><span parentName="span"></span><span parentName="span"></span><span parentName="span"></span><span parentName="span"></span><span parentName="span"></span><span parentName="span"></span></span></pre></div>
    <p>{`replace "SOME_PATH" with a short, descriptive name for your repository. (For instance, Yleo.Common uses `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`common`}</code>{`)`}</p>
    <p>{`Then in the `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`pipelines`}</code>{` section of that file, call that step from an appropriate pipeline (either develop or master makes most sense.) Here is an example of it being called for develop branches:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "yaml"
    }}><pre parentName="div" {...{
        "style": {
          "counterReset": "linenumber NaN"
        },
        "className": "language-yaml line-numbers"
      }}><code parentName="pre" {...{
          "className": "language-yaml"
        }}>{`    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`develop`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{`
      `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`step`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token important"
          }}>{`*build-dotnet`}</span>{`
      `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`step`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token important"
          }}>{`*publish-nugets`}</span>{`
      `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`step`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token important"
          }}>{`*publish-docs`}</span>{`
      `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`step`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token important"
          }}>{`*deploy-docs`}</span>{`            `}</code><span parentName="pre" {...{
          "aria-hidden": "true",
          "className": "line-numbers-rows",
          "style": {
            "whiteSpace": "normal",
            "width": "auto",
            "left": "0"
          }
        }}><span parentName="span"></span><span parentName="span"></span><span parentName="span"></span><span parentName="span"></span><span parentName="span"></span></span></pre></div>
    <p>{`Yours will be slightly different.`}</p>
    <p>{`When you publish documentation for a new project for the first time, it can take up to an hour for those docs to display in the `}<a parentName="p" {...{
        "href": "https://docs.devops.youngliving.com/"
      }}>{`main documentation site`}</a>{`. After the first deployment, updates to those documents will appear as soon as the build is complete.`}</p>
    <p>{`On your index.md, make sure you include frontmatter with a `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`name`}</code>{` attribute like this:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "md"
    }}><pre parentName="div" {...{
        "style": {
          "counterReset": "linenumber NaN"
        },
        "className": "language-md line-numbers"
      }}><code parentName="pre" {...{
          "className": "language-md"
        }}><span parentName="code" {...{
            "className": "token front-matter-block"
          }}><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`---`}</span>{`
`}<span parentName="span" {...{
              "className": "token font-matter yaml language-yaml"
            }}><span parentName="span" {...{
                "className": "token key atrule"
              }}>{`name`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`:`}</span>{` Name of My Site`}</span>{`
`}<span parentName="span" {...{
              "className": "token punctuation"
            }}>{`---`}</span></span></code><span parentName="pre" {...{
          "aria-hidden": "true",
          "className": "line-numbers-rows",
          "style": {
            "whiteSpace": "normal",
            "width": "auto",
            "left": "0"
          }
        }}><span parentName="span"></span><span parentName="span"></span><span parentName="span"></span></span></pre></div>
    <p>{`You can reference the `}<a parentName="p" {...{
        "href": "https://bitbucket.org/youngliving/dotnet-templates/raw/30c5a7fb19a70daed5b839d4f61ffc05b5bb2536/docs/intro.md"
      }}>{`dotnet template project`}</a>{` to see an example of a document with frontmatter.`}</p>
    <p>{`When the docsroot project deploys, you should see a link to your documentation show up on the `}<a parentName="p" {...{
        "href": "https://docs.devops.youngliving.com/"
      }}>{`main documentation site`}</a>{`.`}</p>
    <p>{`Create documentation in your /docs folder using .md or .mdx files.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      